const React = require('react')

import {
  Image,
  Carousel
} from 'react-bootstrap'
const basePath = window.basePath || '';

export default class CollectionBanners extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      collections: window.__COLLECTIONS.map(c => {
        c.banner = c.images.filter(img => img.type == 'banner')[0]
        return c
      }),
    }
  }

  render() {
    return (
      <div>
        {this.state.collections.length > 0 &&
        <Carousel
          slide={this.state.collections.length > 1 ? true : false}
          indicators={false}
          controls={this.state.collections.length > 1 ? true : false}
          interval={this.state.collections.length > 1 ? 5000 : null}
          >
          {this.state.collections.map(c => (
            <Carousel.Item key={c.id}>
              <a href={`${basePath}/sites?collection=${c.id}`}>
                <Image
                  responsive
                  src={c.banner.url}
                  style={{margin: '0 auto', width: '100%'}}
                  alt={c.name}
                />
              </a>
            </Carousel.Item>
          ))}
        </Carousel>
        }
      </div>
    )

  }
}